// #564 T3: Rückfragen und Anfragen aus dem Mieter-/Eigentümerportal – nur über Portal-Funktionen
// (Rolle aus dem Login, Datenbank prüft Zugriff, Länge und Tageslimit). Es wird nichts verschickt.
import { supabase } from '../supabase/client';

export interface PortalNachricht { id: string; von_mir: boolean; inhalt: string; created_at: string }

export const MIN_ANFRAGE_TEXT = 10;
export const MIN_BETREFF = 3;

export function pruefeAnfrage(betreff: string, text: string): { betreff: boolean; text: boolean; ok: boolean } {
  const b = betreff.trim().length >= MIN_BETREFF && betreff.trim().length <= 120;
  const t = text.trim().length >= MIN_ANFRAGE_TEXT && text.trim().length <= 4000;
  return { betreff: b, text: t, ok: b && t };
}

export async function ladeNachrichten(ticketId: string): Promise<PortalNachricht[]> {
  const { data, error } = await supabase.rpc('portal_nachrichten', { p_ticket: ticketId });
  if (error) { console.error('Portal: Nachrichten laden fehlgeschlagen', error.message); return []; }
  return (data as PortalNachricht[] | null) ?? [];
}

export async function sendeNachricht(ticketId: string, text: string): Promise<void> {
  const { error } = await supabase.rpc('portal_nachricht_senden', { p_ticket: ticketId, p_text: text.trim() });
  if (error) throw new Error(error.message);
}

export async function stelleAnfrage(betreff: string, text: string, objektId?: string | null): Promise<{ id: string; ticket_nummer: string }> {
  const { data, error } = await supabase.rpc('portal_anfrage_stellen', { p_betreff: betreff.trim(), p_text: text.trim(), p_objekt: objektId ?? null });
  if (error) throw new Error(error.message);
  return data as { id: string; ticket_nummer: string };
}
